"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
exports.theme = {
    shared: 'underline',
    types: {
        default: {
            layer: 'hover:bg-secondary-200 border-secondary-300',
            text: 'text-secondary-700',
        },
    },
    sizes: {
        default: {
            text: 'text-sm',
        },
        small: {
            text: 'text-xs',
        },
        large: {
            text: 'text-lg',
        },
    },
    states: {
        disabled: {
            layer: elements_ui_utils_1.globalColorClasses.disabled,
        },
        focus: {
            layer: elements_ui_utils_1.globalColorClasses.focus,
        },
    },
};
//# sourceMappingURL=themes.js.map